export enum PassportType {
  NORMAL = 'Normal',
  GREY = 'Grey',
  BLACK = 'Black',
  GREEN = 'Green',
}
